import { reactive } from "vue";
import { Battle } from "../core/battle";
import { Seer } from "../core/seer";
import { createDefaultDraftPool } from "../lib/roster";

export const _battle = reactive(
    new Battle(new Seer(), new Seer(), createDefaultDraftPool()),
) as Battle;
